<!-- 
TabHeaderCustTag.vue
功能：客戶標籤管理_標題列
作者：i9400538 陳博承
完成：2021-10-19
-->
<template>
  <div class="tab-header">
    <div class="container-fluid">
      <ul class="nav nav-tabs narrow" role="tablist" id="business-tab">
        <li
          class="nav-item"
          v-for="(item, i) in tree"
          :class="{
              'dropdown': !item.child===false && item.child.length,
              'active' : currentTab==item.key,
              'd-none' : !setDispaly(item.showType)
            }"
          :id="`tree-item-${i}`"
          :key="`tree-item-${i}`"
        >
          <a
            v-if="!item.child===false && item.child.length"
            data-toggle="dropdown"
            class="nav-link dropdown-toggle"
            role="button"
            aria-haspopup="true"
            aria-expanded="false"
          >{{item.name}}</a>
          <router-link
            :to="item.path"
            v-else
            class="nav-link"
            role="button"
            :data-item="item.key"
            :data-parent="item.key"
          >{{item.name}}</router-link>

          <ul
            v-if="!item.child===false && item.child.length"
            class="dropdown-menu"
            :aria-labelledby="`tree-item-${i}`"
          >
            <li class="dropdown-item" v-for="(val, j) in item.child" :key="`tree-${i}-${j}`">
              <router-link
                :to="val.path"
                role="tab"
                data-toggle="tab"
                :data-item="val.key"
                :data-parent="item.key"
              >
                {{val.name}}
                <i class="text-green float-right">❯</i>
              </router-link>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "TabHeaderCustTag",
  data() {
    return {
      currentTab: "key-6",
      tree: [
        {
          path: "/backend/tab/6",
          key: "key-6",
          name: "編輯標籤",
          showType: ["01"]
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["UserInfo"]),
    // 判斷角色 type
    computedShowType() {
      let divNo = this.UserInfo.divNo;
      let functionId = this.UserInfo.functionId || [];
      // 通路科, 數支科 type = 01
      if (divNo == "9400400" || divNo == "9N00200" || functionId.includes('4')) {
        return "01";
      }
    }
  },
  methods: {
    setDispaly(type) {
      // 判斷權限顯示或隱藏
      if (type.includes(this.computedShowType)) {
        return true;
      } else {
        return false;
      }
    }
  },
  beforeMount() {
    let path = this.$route.path.split(/\//g);
    path.reverse();
    this.currentTab = `key-${path[0]}`;
  }
};
</script>
